import { action, computed, observable, toJS } from 'mobx'
import queryString from 'query-string'

import { Filters } from 'utils'

class QueryStringStore {
  routingStore = null

  @observable
  filters = {}

  @observable
  lastFetchedFilters = {}

  @action
  setFilters(group, filters) {
    this.filters[group] = filters
  }

  @action
  saveCurrentFilters() {
    this.lastFetchedFilters = toJS(this.filters)
  }

  //pensar num jeito melhor de fazer isso!
  @action
  customChanges(group, filter, option) {
    if (filter === 'ages') {
      if (Array.isArray(option)) {
        if (option.length === 0) {
          return Filters.getDefaultFilter({ group, filter })
        }
        if (option.length > 1 && option.some(o => o.value === 'all')) {
          return option.filter(o => o.value !== 'all')
        }
      }
    }
    return option
  }

  @action
  setFilterValue(group, filter, option) {
    this.filters[group][filter] = this.customChanges(group, filter, option)
  }

  @action
  getFiltersByGroup(group) {
    if (this.filters[group]) {
      return this.filters[group]
    }
    return {}
  }

  @action
  setStore(store) {
    this.routingStore = store
  }

  @action
  hasFilters(group) {
    return this.filters?.[group] !== undefined
  }

  @action
  getLastFetchedFilters(group) {
    return this.lastFetchedFilters[group] || this.filters[group]
  }

  @computed
  get parsed() {
    if (this.routingStore?.location) return queryString.parse(this.routingStore.location.search)
    return {}
  }

  @computed
  get stringified() {
    return queryString.stringify(this.parsed)
  }

  evaluate(string, regexp) {
    if (regexp instanceof RegExp) {
      return !regexp.test(string)
    } else {
      return string.toLowerCase() !== regexp.toLowerCase()
    }
  }

  cleanByTerm(regexp, object) {
    return Object.entries(object)
      .map(a => a[1] && this.evaluate(`${a[1]}`, regexp) && { [a[0]]: a[1] })
      .filter(Boolean)
      .reduce((acc, v) => Object.assign(acc, v), {})
  }

  merge(defaults) {
    return { ...defaults, ...this.parsed }
  }

  @action
  parse({ filter, defaults = {} } = {}) {
    if (!filter || (!(filter instanceof RegExp) && typeof filter !== 'string')) return this.merge(defaults)
    return this.cleanByTerm(filter, this.merge(defaults))
  }

  @action
  stringify({ filter, defaults }) {
    if (!filter || (!(filter instanceof RegExp) && typeof filter !== 'string'))
      return queryString.stringify(this.merge(defaults))
    return queryString.stringify(this.cleanByTerm(filter, this.merge(defaults)))
  }
}

export default new QueryStringStore()
